@if (title) {
  <h3>{{ title }}</h3>
}

<ng-content></ng-content>

@if (opret.observers.length !== 0) {
  <div class="opret">
    <button mat-mini-fab type="button" color="basic" matTooltip="Opret" (click)="onOpretClick()">
      <mat-icon svgIcon="plus"></mat-icon>
    </button>
  </div>
}
